import { useContext } from "react";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Status from "./status";
import Dashboard from "./dashboard";
import Certificate from "./certificate";
import AdminLogin from "./adminlogin";
import UploadPolicy from "./uploadpolicy";
import { createTheming } from "../utils/Theme";
import AuthLayout from "../layouts/AuthLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import SettingsContext from "../context/SettingsContext";
import CheckStatus from "./checkstatus";
import Scanner from "./scanner";
import ScreenDamageTest from "./screendamagetest";
import CameraRecorder from "./camerarecorder";
import ScreenDamageConfirmation from "./screendamageconfirmation";
import Instructions from "./instructions";
import QrScannerError from "./qrScannerError";

function App() {
  const themeSeeting = useContext(SettingsContext);
  const theme = createTheming({
    theme: themeSeeting.settings.theme,
  });

  return (
    <ThemeProvider theme={theme}>
      {/* Uncomment the next line for the build purpose on test env */}
      <Router basename="/">
        <Routes>
          {/* <Route path="/" element={<ScreenDamageConfirmation />} /> */}
          {/* Universal routes can be added here if needed in the future */}
          <Route path="/" element={<UploadPolicy />} />
          <Route path="/download-certificate" element={<Certificate />} />
          <Route path="/checkstatus" element={<CheckStatus />} />

          {/* primary phone route  */}
          <Route path="/apb-scanner" element={<Scanner />} />
          <Route path="/screen-damage-test" element={<ScreenDamageTest />} />
          <Route path="/instructions" element={<Instructions />} />
          <Route path="/apb-scanner-error" element={<QrScannerError />} />

          {/* secondry phone route */}
          <Route path="/camera-recorder" element={<CameraRecorder />} />

          {/* Auth Layout */}
          <Route
            path="/admin-signin"
            element={
              <AuthLayout>
                <AdminLogin />
              </AuthLayout>
            }
          />

          <Route
            path="/admin-dashboard"
            element={
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            }
          />
          <Route path="/status" element={<Status />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <ToastContainer position="top-right" />
      </Router>
    </ThemeProvider>
  );
}

export default App;
